"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var throttle_utils_1 = __importDefault(require("../../../utils/throttle.utils"));
var DauTimePlugin = (function () {
    function DauTimePlugin(ctx, options) {
        if (options === void 0) { options = {}; }
        window.addEventListener('scroll', throttle_utils_1.default(function () {
            try {
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                var _a = options.reportParams, reportParams = _a === void 0 ? {} : _a;
                ctx.reportUserAction(Object.assign({}, reportParams, {
                    user_action: 'tkd_watched_height',
                    height: "" + scrollTop,
                }));
            }
            catch (error) {
                console.log('DauTimePlugin error', error);
            }
        }, 300));
    }
    return DauTimePlugin;
}());
exports.default = DauTimePlugin;
//# sourceMappingURL=read-height-reporter.plugin.js.map